import React from "react";
import styled from "@emotion/styled";

import { Colors } from "../../styles";

const SidePanelDots = ({ numOfSlides, isSelected, handleSelectSlide }) => {
	const handleChange = (index) => {
		handleSelectSlide(index);
	};

	const dots = [];
	// numOfSlides is length of data array, need to turn into an array of dot elements
	for (let i = 0; i < numOfSlides; i++) {
		const isChecked = isSelected(i) ? "checked" : "";
		dots.push(
			<label className="radio-btn" htmlFor={`dots-${i}`} key={`dots-${i}`} aria-label={`Go to slide ${i + 1}`}>
				<input className="radio-btn__input" type="radio" name="dots" value={i} id={`dots-${i}`} checked={isChecked} onChange={() => handleChange(i)}></input>
				<span className="checkmark"></span>
			</label>
		);
	}

	return <DotsContainer>{dots}</DotsContainer>;
};

export default SidePanelDots;

const DotsContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, 25px);
	grid-auto-rows: auto;
	gap: 0.5rem;
	justify-content: center;

	width: 100%;
	height: 6rem;
	padding: 0 2rem;
	margin-top: 3.5rem;

	.radio-btn {
		display: block;
		position: relative;
		cursor: pointer;
		user-select: none;
		height: 12px;
		width: 12px;
		aspect-ratio: 1;

		&:hover .checkmark {
			background: ${Colors.base.beigeDark};
		}
		
		&__input:checked ~ .checkmark {
			background: ${Colors.base.red};

			&::after {
				display: block;
			}
		}

		&__input {
			position: absolute;
			opacity: 0;
			cursor: pointer;
			width: 0;
			height: 0;
		}
		.checkmark {
			position: absolute;
			top: 0;
			left: 0;
			height: 100%;
			width: 100%;
			background: ${Colors.base.beigeLight};
			border-radius: 50%;
		}
	}
`;
